<template>
  <a class="in-dm-card-button" :href="safeUrl || undefined" target="_blank" rel="noopener noreferrer">
    {{ name }}
  </a>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { sanitizeHttpUrl } from '@/client/utils/string'

interface Props {
  name: string
  url: string
}
const props = defineProps<Props>()

const safeUrl = computed(() => sanitizeHttpUrl(props.url))
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/in-dm.scss' as *;
@use '@/client/assets/scss/variables.scss' as *;

.in-dm-card-button {
  display: block;
  width: 100%;
  padding: $spacing-unit $spacing-unit * 2;
  font-size: $font-size;
  font-weight: $font-weight-bold;
  color: $in-dm-btn-text;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  background: $in-dm-btn-bg;
  border-radius: 12px;
  transition:
    color 0.15s,
    background 0.15s;

  &:hover {
    color: $in-dm-btn-hover-text;
    background: $in-dm-btn-hover-bg;
  }
}
</style>
